












import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { namespace } from 'vuex-class';
import { AcgnTable, AcgnTableButtonGroup } from '@acgn/herm/src/ui';
import { AcgnApprovalDetail } from '@/components';

const StatisticNorAction = namespace('desk/statisticNor').Action;
const StatisticAction = namespace('desk/statistic').Action;

const StatisticNorGetter = namespace('desk/statisticNor').Getter;

@Component({
  components: {
    AcgnTable,
    AcgnTableButtonGroup,
    AcgnApprovalDetail
  }
})

/**
 * 逾期提交
 */
export default class AcgnOverdueCommitDetail extends Vue {

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 员工id

  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  @StatisticNorAction private getOverdueSubDetail: any;
  @StatisticAction private getOverdueSubAdminDetail: any;

  @StatisticNorGetter private loadings: any; // loading

  private apiKey: any = {
    1: 'getOverdueSubDetail',
    2: 'getOverdueSubAdminDetail'
  };

  private popData: any = {
    visible: false,
    data: {}
  };

  private tableConfig: any = {
    columns: [
      {
        label: '员工姓名',
        prop: 'uname',
        width: 180
      },
      {
        label: '逾期环节',
        prop: 'link_name'
      },
      {
        label: '提交截止时间',
        prop: 'over_submit_time'
      },
      {
        label: '提交时间',
        prop: 'submit_time'
      },
      {
        label: '操作',
        prop: 'action',
        minWidth: 100,
        fixed: 'right',
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const btns = [
            {
              color: '#73c800',
              text: '查看',
              type: 'edit',
              to: {
                name: 'desk-comicAuthTask',
                params: {
                  id: this.comicId,
                  task_group_id: row.task_group_id,
                  task_id: row.task_id
                }
              },
              disabled: false
            },
            {
              color: '#73c800',
              text: '审批详情',
              type: 'detail',
              disabled: false
            }
          ];
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                this.onListAction(item);
              },
            },
          });
        }
      }
    ],
    data: []
  };

  private pageConfig: any = { // 分页数据
    total: 0,
    currentPage: 1
  };

  private async initSearh({ page }: { page: any }) {
    const { tableConfig, pageConfig } = this;
    const options = {
      page,
      size: 30,
      project_id: this.comicId,
      user_id: this.userId

    };
    const { result, paging } = await (this as any)[this.apiKey[this.type]](options);
    tableConfig.data = result.list;
    pageConfig.currentPage = paging.page;
    pageConfig.pageSize = paging.size;
    pageConfig.total = paging.total;

    const { size, ...args } = options;
    this.$setFormCache({ ...args });
  }

  // 列表操作项
  private onListAction(item: any) {
    const row = item.row;
    switch (item.type) {
      case 'detail':
        this.popData.data = {
          linkId: row.link_id
        };
        this.popData.visible = true;
        break;
    }
  }
}
